module.exports = __webpack_public_path__ + "img/demo.ab49ab53.png";